<div class="dialog-panel">
  <h2 class="dialog-title text-h3 font-brand">{{ 'appUpdate.title' | translate }}</h2>
  <p class="dialog-intro text-body-sm text-muted">
    {{ 'appUpdate.message' | translate }}
  </p>

  <div class="dialog-actions">
    <button type="button" class="btn-primary" (click)="refresh()">
      <mat-icon>refresh</mat-icon>
      {{ 'appUpdate.refresh' | translate }}
    </button>
  </div>
</div>
